<template>
    <div class="baseBody">
        <ScaleBox>
            <div class="main-wraper relative">
                <div id="container"
                    style="width: 100%;height: 100%;position: absolute;z-index: 100;left: 0px;top:48px;">
                </div>
                <!-- <div class="bgImg"></div> -->
                <div class="custBodybg" style="pointer-events: none;"></div>
                <div class="dateWeek">
                    <DynamicDate></DynamicDate>
                </div>
                <div class="fullBox">
                    <ScreenfullBox></ScreenfullBox>
                </div>
                <div class="baseTitleContent">
                    <div class="baseTitleMid">
                        <div class="top">
                            <div class="topLine">
                                <div class="title text-center  text-white text-bold" style="font-size: 32px;">31再生资源平台大数据面板</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="position: fixed;width:100%;left:0;top:0;z-index:999;pointer-events:none;">
                    <div class="flex align-center justify-between">
                        <div>
                            <div class="baseTitleLeft"></div>
                        </div>
                        <div>
                            <div class="baseTitleRight"></div>
                        </div>
                    </div>
                </div>
                <div style="width:25% ;position: fixed;top: 60px;left:0;z-index: 999;">
                    <LeftContent></LeftContent>
                </div>
                <div style="width:50% ;position: fixed;top: 60px;left:25%;z-index: 999;">
                    <MidContent ref="midData" ></MidContent>
                </div>
                <div style="width:25% ;position: fixed;top: 60px;right:0;z-index: 999;">
                    <RightContent></RightContent>
                </div>
                

            </div>
        </ScaleBox>
      
        <el-dialog title="提示" :show-close="false" custom-class="custBoyModal" :visible.sync="dialogVisibleModalsible" width="384px" >
            <div class="modalContent">
               <div class="text-center base-font-18 text-bold">{{siteObj.siteName}}</div>
                <div class="margin-top-15 base-font-16">描述：{{siteObj.description}}</div>
         <!--       <div >确定跳往{{siteObj.siteName}}大数据看板吗？</div>
                <div>确定</div> -->
                <div class="goLinkBtn text-center" @click="goLink">前往{{siteObj.siteName}}看板</div>
            </div>
            <div class="text-center margin-top-20" style="width:384px;">
                <i class="el-icon-circle-close base-font-30 text-white pointer" @click.stop="showModal"></i>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import AMapLoader from "@amap/amap-jsapi-loader";
    import DynamicDate from "../components/dynamicDate/index.vue";
    import ScreenfullBox from "../components/screenfull/index.vue";
    import ScaleBox from "../components/sacleBox/index.vue";
    import LeftContent from './components/ptkb/leftContent.vue'
    import RightContent from './components/ptkb/rightContent.vue'
    import MidContent from './components/ptkb/midContent.vue'
    import {ptCenterData} from "@/api/api";
    export default {
        components: {
            LeftContent,
            RightContent,
            ScaleBox,
            DynamicDate,
            ScreenfullBox,
            MidContent
        },
        data() {
            return {
                map: '',
                lineList: [],
                postionList: [],
                runMakerList: [],
                dialogVisibleModalsible:false,
                sites:[],
                siteObj:{},
				timer:null
                
               
            }
        },
        mounted() {

            this.changeData();
			this.timer = setInterval(() => {
			  this.changeData();
			}, 60000); // 60秒 = 60000毫秒
        },
		beforeDestroy() {
		    // 组件销毁前清除定时器，避免内存泄漏
		    if (this.timer) {
		      clearInterval(this.timer);
		    }
		  },
        methods: {
            changeData() {
                let _self = this
                ptCenterData().then(res => {
                    _self.sites=res.data.sites
                  _self.$nextTick(function() {
                      _self.$refs.midData.getData(res.data)
                     _self.initAMap();
                  });
                });
            },

            initAMap() {
                AMapLoader.load({
                    key: '18997a286e73c2d94837b10f89516387', // 高德地图API Key
                    version: '2.0', // 指定API版本
                    plugins: ["AMap.ControlBar", "AMap.ToolBar"], // 需要使用的插件
                    AMapUI: {
                        version: '1.1',
                        plugins: []
                    }
                }).then((AMap) => {
                    let longitude = '105.985966';
                    let latitude = '26.206922';
                    this.postionList = [];
                    this.sites.forEach((obj) => {
                         this.postionList.push(obj);
                    })
                    if (this.postionList.length > 0) {
                        longitude = this.postionList[0].longitude;
                        latitude = this.postionList[0].latitude;
                    }
                    this.map = new AMap.Map('container', {
                        rotateEnable: true,
                        pitchEnable: true,
                        zoom:10,
                        rotation: -15,
                        viewMode: '3D', //开启3D视图,默认为关闭
                        zooms: [2, 20],
                        center: [longitude, latitude]
                    });
                    this.map.setMapStyle('amap://styles/darkblue');
                    this.setPostion(AMap);


                }).catch(e => {
                    console.log(e);
                });
            },
            setPostion(AMap) {
                let pointList = [];

                let _self=this
                this.postionList.forEach((pointObj,index) => {
                    // console.log(pointObj,pointObj.localImg,'111')
                    let title = '';
                    let logoImage=''
                    if (pointObj.siteName) {
                        title += "<br/>" + pointObj.siteName;
                    }
                    if(pointObj.logoImage){
                        logoImage=pointObj.logoImage
                    }else{
                        logoImage="https://31hs.oss-cn-beijing.aliyuncs.com/diy/diySwiper/202507180916332025071809163304230754227.png"
                    }
                    title =
                        "<div  style='background: url(https://31hs.oss-cn-beijing.aliyuncs.com/diy/diySwiper/202507221140432025072211404304910884586.png) top center no-repeat;background-size:290px;height:51px;width:290px;height:51px;line-height:18px;color:#ffffff;font-size:18px;text-align:center;font-weight:bold'>" +
                        title + "</div>"
                    let point = new AMap.Marker({
                        position: [pointObj.longitude, pointObj.latitude],
                        icon: new AMap.Icon({
                            // 图标尺寸
                            size: new AMap.Size(65, 75),
                            // 图标的取图地址
                            image:logoImage ,
                            // 图标所用图片大小
                            imageSize: new AMap.Size(65, 75),
                        }),
                        offset: new AMap.Pixel(0, 0), //设置偏移量
                        label: {
                            direction: 'top',
                            content: title,
                            offset: new AMap.Pixel(0, -5),
                        }
                    });
                    point.on("click",function(){
                       _self.siteObj=_self.sites[index]
                         _self.dialogVisibleModalsible=true
                    })
                    pointList.push(point);
        
                })
                this.map.add(pointList);
            },
            setLinerList(AMap) {
                this.lineList.forEach((obj) => {
                    this.setLiner(AMap, obj);
                })
            },
            showModal(){
                
                this.siteObj={}
                 this.dialogVisibleModalsible=false
            },
            goLink(){
                this.$router.push({ name: 'fjzx', query: { siteId:this.siteObj.id,name:this.siteObj.siteName } });
            }
  
     
  
       
        }
    }
</script>


<style lang="scss" >
    .amap-marker-label {
        background: none !important;
        border: none;
    }
    .pointer{cursor: pointer;}
    .custBoyModal{
        background: none;
            width:384px;
            .modalContent{
                width:384px;
                height: 244px;line-height:1.5;
                padding:50px 45px;box-sizing: border-box;
                margin: 0 auto;text-align: center;color:#FFFFFF;
                background: url('../assets/img/06.png') top left no-repeat;
                background-size: 100% 100%;
                text-align: left;
            }
    }
    .baseBody {
        width: 100%;
        height: 100vh;
        overflow: hidden;
        position: relative;
        font-size: 14px;
        background: #000208;
        position: relative;

        .main-wraper {
            user-select: none;
            width: 1920px;
            height: 1080px;
            margin: 0 auto;
            background: #02081a url('../assets/images/sytBg2.png') center no-repeat;
            background-size: cover;
            box-sizing: border-box;
        }

    }

    .dateWeek {
        position: absolute;
        top: 0;
        left: 0;
        width: 200px;
        height: 50px;
        color: #ffffff;
        z-index: 200;
    }

    .fullBox {
        position: absolute;
        top: 0;
        right: 0;
        width: 200px;
        height: 50px;
        color: #ffffff;
        z-index: 999;
    }

    .nyBaseHeadTop {
        width: 100%;
        height: 80px;
        background: url('../assets/images/titleBg.png') top center no-repeat;
        background-size: auto 80px
    }

    .base-headTit {
        font-size: 30px;
        font-weight: bold;
        box-sizing: border-box;
        padding-top: 24px;
    }

    .baseTitleLeft {
        width: 644px;
        height: 55px;
        background: url('../assets/images/titleLeft.png') top right no-repeat;
        background-size: auto 55px
    }

    .baseTitleRight {
        width: 644px;
        height: 55px;
        background: url('../assets/images/titleRight.png') top left no-repeat;
        background-size: auto 55px
    }

    .baseBody .baseTitleContent {
        width: 100%;
        height: 100px;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        z-index: 200;
    }

    .baseBody .baseTitleContent .baseTitleMid {
        width: 659px;
        height: 100px;
        margin: 0 auto;
        background: url('../assets/images/headtitileBg3.png') top left no-repeat;
        background-size: auto 100px
    }

    .baseBody .baseTitleContent .baseTitleMid .top {
        width: 659px;
        height: 100px;
        margin: 0 auto;
        background: url('../assets/images/headtitileBg2.png') top left no-repeat;
        background-size: auto 100px
    }

    .baseBody .baseTitleContent .baseTitleMid .topLine {
        width: 659px;
        height: 100px;
        margin: 0 auto;
        background: url('../assets/images/titleBg4.png') top left no-repeat;
        background-size: auto 100px
    }

    .baseBody .baseTitleContent .baseTitleMid .title {
        width: 402px;
        height: 70px;
        margin: 0 auto;
        font-size: 34px;
        font-weight: bold;
        line-height: 70px;
        background: url('../assets/images/headtitileBg1.png') top left no-repeat;
        background-size: auto 70px
    }

    .dataItem {
        width: 180px;
        height: 95px;
        line-height: 1;
        margin: 0 auto;
        text-align: center;
        color: #FFFFFF;
        background: url('../assets/img/04.png') top left no-repeat;
        background-size: 100% 100%;
        padding-top: 18px;
        box-sizing: border-box;

        .title {
            font-size: 18px;
            font-weight: bold;
        }

        .num {
            font-size: 41px;
            font-weight: bold;
            margin-top: 10px;
            color: #43eb93;

            &.yc {
                color: #ff8a00;
            }

            &.blue {
                color: #00d8ff;
            }

            &.purper {
                color: #c62bff;
            }

            &.red {
                color: #ff94a3;
            }

            s &.yellow {
                color: #fdc671;
            }
        }
    }
    .bgImg{
            width:1920px;
            height: 1080px;line-height:1;
            margin: 0 auto;text-align: center;color:#FFFFFF;
            background: url('../assets/img/bg.png') top left no-repeat;
            background-size: 100% 100%;position:fixed;left:0;top:0;z-index: 120;pointer-events: none;
    }
    .custBodybg{
        width:1920px;
        height: 1080px;position:fixed;left:0;top:0;z-index: 100;pointer-events: none;
         background: -webkit-radial-gradient(rgba(0,12,38,0) 30%,#000c26 100%,#000c26 100%); /* Safari 5.1 - 6.0 */
          background: -o-radial-gradient(rgba(0,12,38,0) 30%,#000c26 100%,#000c26 100%); /* Opera 11.6 - 12.0 */
          background: -moz-radial-gradient(rgba(0,12,38,0) 30%,#000c26 100%,#000c26 100%); /* Firefox 3.6 - 15 */
          background: radial-gradient(rgba(0,12,38,0) 30%,#000c26 100%,#000c26 100%); /* 标准的语法 */
    }
    .goLinkBtn{border:1px solid rgba(255, 255, 255, 0.9);height:35px;line-height: 35px;font-size:15px;text-align: center;border-radius: 17px;margin-top: 30px;cursor: pointer;
     &:hover{background: rgba(255, 255, 255, 0.9);color: #000c26;}
    }

</style>